<template>
  <div class="card">
    <table class="table table-sm table-bordered table-striped">
      <thead class="bg-primary text-white text-center">
        <tr>
          <th>#</th>
          <th>Nome</th>
          <th>Consulta Totvs</th>
          <th>Atualizar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="query in queries" :key="query.id">
          <td class="p-1 text-center">{{ query.id }}</td>
          <td>
            {{ query.name }}
            <br />
            <small class="text-muted">{{ query.description }}</small>
          </td>
          <td>
            <select
              name="query-totvs-id"
              :id="`queryTotvsId${query.id}`"
              v-model="query.queryTotvsId"
              class="form-select"
            >
              <option value="" selected disabled>Selecione uma opção</option>
              <option
                v-for="queryTotvs in queriesTotvs"
                :key="queryTotvs.id"
                :value="queryTotvs.id"
                :title="queryTotvs.comments"
              >
                {{ queryTotvs.code }}
              </option>
            </select>
          </td>
          <td class="p-1 text-center">
            <button
              type="button"
              class="btn btn-sm btn-outline-success btn-icon"
              title="Atualizar Consulta"
              @click="$emit('saveQuery', query)"
            >
              <i class="ph-floppy-disk" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ListQueries',

  props: {
    queries: {
      type: Array,
      required: true,
    },
    queriesTotvs: {
      type: Array,
      required: true,
    },
  },
}
</script>
